import React, { PureComponent } from "react";

import styles from "./Search.local.scss";
//import classnames from "classnames";

import Categories from "../Categories";
// import _ from "i18n";
import TagSelect from "Common/TagSelect";

export default class SearchComponent extends PureComponent {
  state = {
    tag: null
  };

  onInputChange = e => {
    const { setFilter, fetchMedias } = this.props;
    let filter = this.props.filter;
    filter.search = e.target.value;
    setFilter(filter);
    if (filter.search === "") {
      fetchMedias({ filterBy: filter, limit: 42 });
    }
  };

  handleClick = e => {
    const { filter, fetchMedias } = this.props;
    if (filter.search.length > 2) {
      fetchMedias({ filterBy: filter, limit: 42 });
    }
  };

  handelChange = tag => {
    const { setFilter, fetchMedias } = this.props;
    let filter = this.props.filter;
    if (filter.type === "ALBUM") filter.type = "ALL";
    if (tag && tag.id) {
      filter.tags = [tag];
      filter.category = "";
      setFilter(filter);
      fetchMedias({ filterBy: filter, limit: 42 });
    } else {
      filter.tags = [];
      setFilter(filter);
      fetchMedias({ filterBy: filter, limit: 42 });
    }
  };

  render() {
    const { lng, filter } = this.props;
    return (
      <div className={styles.search}>
        <div className={styles.searchArea}>
          <TagSelect
            onChange={this.handelChange}
            tag={filter.tags[0]}
            lng={lng}
          />
          {/* <input
            type="text"
            placeholder={_("Search by keyword...")}
            value={filter.search}
            onChange={this.onInputChange}
          /> */}
          {/* <button
            className={filter.search.length > 2 ? styles.activated : ""}
            onClick={this.handleClick}
          >
            <i className="icon icon-magnifier" />
            {_("Search")}
          </button> */}
        </div>
        <Categories />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/Header/Search/SearchComponent.js